
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../Services/common.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';

import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { debug } from 'util';
import { AppDataService } from "../../Services/app-data-service";
import { DatePipe } from '@angular/common';
import { ThrowStmt } from '@angular/compiler';
import { ApiService } from '../../common/API/api.service';

declare var config: any;
@Component({
  selector: 'app-FrontPhoneGradingDeduction',
  templateUrl: './FrontPhoneGradingDeduction.component.html',
  styleUrls: ['./FrontPhoneGradingDeduction.component.css']
})
export class FrontPhoneGradingDeductionComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public freshRecords : any [];
  public Userlist;
  public selectedEnterprise;
  public UserInfo
  enterpriseClientData: any;
  UserData: any;
  EnterprisePartenerModalList: any;
  StoreDetails: any;
  AllStoreDetails: any;
  RecordsList: any[];
  GradeList: any[];
  GradePrice: any[] = [];
  ShowGrade: any[] = [];
  SaveGradeList: any[] = [];
  IsSubmit: boolean = false;
  IsDisabled:boolean= true;
  SearchSKUID: any;
  SearchMakeModel: '';
  disableReset: boolean = true;

  DeviceCategoryList: any;
  DeviceCategoryID: any;
  DeviceCategory: any='Phones & iPad';

  public GradeDataList= [];

  public Enterprisedata = [];
  Enterpriselist: any;
  public Datemodel: any;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: false,
    //disableUntil: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() - 1 },
  };
  TemporaryData: any;
  PriceEdit: string;
    public dataSource: any;
    public displayedColumnsConsoles = ['SKUID', "DeviceVendor", 'DeviceModel', 'StorageCapacity', 'DeviceFullPrice', 'Grade_C', 'Grade_D', 'Grade_E', 'Grade_F'];
    public displayedColumnsConsolesBackend = ['SKUID','DeviceVendor', 'DeviceModel', 'StorageCapacity', 'DeviceFullPrice','Grade_A','Grade_B', 'Grade_C', 'Grade_D', 'Grade_E', 'Grade_F'];
  FrontendBackendDetails: any;
  FrontGradeDataList: boolean = false;
  BackGradeDataList: boolean  = false;
  BackendData: any;
  FrontendData: any;
  length: any;
  latest_date: string;
  EnterprisePartnerID: any;
  Enterprise: any;
  EnterpriseID: string;
  SelectModino: boolean  = false;
  IsITAD: boolean  = false;
  form: FormGroup;
  logform: FormGroup;
  selectedFrontBackProfileID: any;
  isSearchBtnDisabled: boolean;
  
  constructor(private fb: FormBuilder,
    private appData: AppDataService, private datePipe: DatePipe,
    private spinner: NgxSpinnerService, private formbuilder: FormBuilder, private _service: CommonService, private router: Router, private toasterservice: ToastrService, private _apiService: ApiService) {
      this.form = formbuilder.group({
        EnterprisePartner: ['0', Validators.required],
        Enterprise: ['0', Validators.required]
      });
  }



  ngOnInit() {
    debugger
    this.EnterprisePartnerID = 0;
    this.DeviceCategoryID =1;
   this.EnterpriseID = "1";
  this.IsITAD=true;
     this.DeviceCategory =config.DeviceCategory;
    this.Enterprise = config.Enterprise;
    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.UserInfo = JSON.parse(sessionStorage.getItem('user'));

    const datestring = sessionStorage.getItem('PriceSelectedDate');
    const myDate = new Date();
    
    debugger
    this.latest_date = this.datePipe.transform(myDate, 'MM/dd/yyyy');
    //this.Datemodel = this.datePipe.transform(myDate, 'MM/dd/yyyy');
    // if (datestring) {
    //   const selectedDate = new Date(datestring);
    //   this.Datemodel = { date: { year: selectedDate.getFullYear(), month: selectedDate.getMonth() + 1, day: selectedDate.getDate() } };
    //  // this.latest_date =    this.datePipe.transform((this.Datemodel.day+this.Datemodel.month+this.Datemodel.year),"MM/DD/YYYY")
    // } else {
       this.Datemodel = { date: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() } };
    //  // this.latest_date =     (selectedDate.getMonth() + 1  / selectedDate.getDate() /selectedDate.getFullYear()).toString();
    //  // this.latest_date =this.datePipe.transform(this.Datemodel, 'mm/DD/yyyy');
    // }
    


    if (this.UserInfo == null) {
      this.router.navigate(['/login']);
    }

  this.FrontendBackendDetails=config.FrontendBackendProfiles;

this.getDisplaySkuPricedata(this.FrontendBackendDetails[0].FrontendBackendProfileID);
  }


 
 
  getDisplaySkuPricedata(FrontendBackendProfileID) {
    debugger;
    if(this.EnterpriseID =="1")
    {
    //  var enterprise = this.Enterprise.find(x => x.EnterpriseID === Number(this.EnterpriseID));
      this.EnterprisePartnerID ="2";
    }
    else if(this.EnterpriseID =="3")
    {
      this.EnterprisePartnerID ="23";
    }
    else if(this.EnterpriseID =="4")
    {
      this.EnterprisePartnerID ="27";
    }
    else if(this.EnterpriseID =="5")
    {
      this.EnterprisePartnerID ="29";
    }
    else if(this.EnterpriseID =="6")
    {
      this.EnterprisePartnerID ="30";
    }
    this.spinner.show();
    this.IsDisabled = true;
      const param = {
        DeviceCategoryID: this.DeviceCategoryID,
        FrontendBackendProfileID: FrontendBackendProfileID,
        SKUID:this.SearchSKUID,
        DeviceModel:this.SearchMakeModel,
        PriceStartDate:this.latest_date,
        EnterprisePartnerID: this.EnterprisePartnerID,

        
      };

     this._service.getData(param, 'api/pricing-get-frontend-sku-models-price').then(res => {
debugger
 this.spinner.show();
 this.selectedFrontBackProfileID = FrontendBackendProfileID;
 this.BackGradeDataList = false;
 this.FrontGradeDataList = false;
 if(FrontendBackendProfileID==this.FrontendBackendDetails[0].FrontendBackendProfileID){
  this.FrontGradeDataList = true;
  this.BackGradeDataList = false;
  this.FrontendData = res;
  this.dataSource=new MatTableDataSource(this.FrontendData);
  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
    //  this.dataSource.paginator = this.paginator;
     this.length=res.length;
    //  this.dataSource.sort = this.sort;
     this.spinner.hide();
}
else{

 
  this.BackGradeDataList = true;
  this.FrontGradeDataList = false;
  this.BackendData = res;
  this.dataSource=new MatTableDataSource(this.BackendData);
  setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);

    //  this.dataSource.paginator = this.paginator;
     this.length=res.length;
    //  this.dataSource.sort = this.sort;
     this.spinner.hide();
}
  
        this.spinner.hide();

      });


  }

  onDateChanged(event) {
    debugger
   // const formattedDate = new Date(event.formatted);
    this.latest_date =event.formatted
    console.log(this.latest_date)
    
  }





  

  Searchfilter() {
    debugger
 


    // if (this.SearchSKUID === '' && this.SearchMakeModel === '') {

      
    //   return;
    // } else if (this.SearchSKUID !== '' && this.SearchMakeModel === '') {
    
     
    // } else if (this.SearchSKUID === '' && this.SearchMakeModel !== '') {

   
    // } else if (this.SearchSKUID !== '' && this.SearchMakeModel !== '') {
      

    // }
    if( this.FrontGradeDataList){
      this.getDisplaySkuPricedata(this.FrontendBackendDetails[0].FrontendBackendProfileID);
    }
    else{
      this.getDisplaySkuPricedata(this.FrontendBackendDetails[1].FrontendBackendProfileID);
    }
 


    this.disableReset = false;
  }

  resetfilter() {
    this.spinner.show();
    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.IsDisabled = true;
    this.EnterprisePartnerID = "0";
    this.EnterpriseID = "1";
     this.SelectModino = false;
     this.dataSource ='';
    //this.DeviceCategoryList = JSON.parse(sessionStorage.getItem('filter'));
    sessionStorage.removeItem('filter');
    const myDate = new Date();
    this.latest_date = this.datePipe.transform(myDate, 'MM/dd/yyyy');
    this.Datemodel = { date: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() } };

    this.getDisplaySkuPricedata(this.DeviceCategoryID);
    this.disableReset = true;
    //this.spinner.hide();

  }

  discardChanges() {

    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.IsDisabled = true;
    this.disableReset = true;
   // this.GradeDataList.SkuModelData= ''
    this.TemporaryData= JSON.parse(sessionStorage.getItem('TemporaryData'));
    // this.GradeDataList.SkuModelData =  this.TemporaryData;
  }



  onChangeEnterprise(event) {
    debugger
    this.IsITAD=false;
    this.DeviceCategoryID =config.DeviceCategoryID;
    if (event == "0" || this.DeviceCategoryID == 0) {
      return false;
    }
    else if (event == "1") {
      this.SelectModino = false;
    this.IsITAD=true;
    this.DeviceCategoryID = "0"
    }
    else if (event == "1" || event == "3"  || event == "4"|| event == "5" || event == "6") {
      this.SelectModino = false;
      this.disableReset = false;
      this.dataSource ='';
      this.FrontendBackendDetails=config.FrontendBackendProfiles;
   this.getDisplaySkuPricedata(this.selectedFrontBackProfileID);
    }
    else{
      this.dataSource ='';
      this.SelectModino = true;
      this.EnterprisePartnerID = "0";
      this.disableReset = false;
      this.isSearchBtnDisabled=true;
      this.getEnterprise_EnterprisePartner();
   
    
    }
   
  }

  OnChangeEnterprisePartner(PartnerID)
  {
    this.dataSource ='';
    this.isSearchBtnDisabled=false;
    this.FrontendBackendDetails=config.FrontendBackendProfiles;
   this.getDisplaySkuPricedata(this.selectedFrontBackProfileID);
   this.disableReset = false;
  }

 
  getEnterprise_EnterprisePartner() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
      this.spinner.hide();
      if (result.IsSuccess) {
        this.Enterpriselist = result.Data.Table1.filter(X => X.IsActive !== false);
        this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID && X.IsActive !== false);
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  OnChangeDeviceCategory(deviceCategoryID) {
    debugger;
    this.DeviceCategoryID = +deviceCategoryID;
    if (deviceCategoryID != "0") {
   this.dataSource ='';
    this.isSearchBtnDisabled=false;
    this.FrontendBackendDetails=config.FrontendBackendProfiles;
   this.getDisplaySkuPricedata(this.selectedFrontBackProfileID);
   this.disableReset = false;
    }
    else{
      // this.notifier.notify('error', 'Please choose device category');
    }
  }
}




